/**
 * 简体中文本地化资源
 * E.1 + E.3-1 + E.3-2 累计 key
 */
export default {
  layout: {
    brand: 'CardShop 自助购卡机',
    loading: '正在加载，请稍候…',
    offline: '网络连接已断开',
  },
  error: {
    network: '网络连接失败，请检查网络设置',
    unknown: '发生未知错误，请联系工作人员',
    maintenance: '系统维护中，请稍候',
  },
  common: {
    btn: {
      confirm: '确认',
      cancel: '取消',
      retry: '重试',
      copy: '复制',
    },
  },
  // ── E.3-1 ─────────────────────────────────────────────────────────────────
  home: {
    welcome: '欢迎使用 CardShop 自助购卡机',
    start: '开始购卡 / Start',
    startAria: '点击开始购卡',
    allCategories: '全部',
  },
  products: {
    title: '选择商品 / Select Product',
    back: '返回',
    lowStock: '即将售罄',
    outOfStock: '已售罄',
    empty: '暂无可购商品',
    loading: '正在加载商品…',
    createOrderFailed: '创建订单失败，请重试',
    activeOrderExists: '您有一个未完成的订单，请先处理或等待其超时释放',
    activeOrderExistsRedirecting: '检测到进行中的订单，正在为您跳转...',
  },
  order: {
    title: '订单详情 / Order Detail',
    back: '返回',
    payNow: '去支付 / Pay Now',
    cancel: '取消订单 / Cancel',
    notFound: '订单不存在，请重新下单',
    cancelComingSoon: '取消订单功能将在下一期实装',
    status: {
      PENDING: '待处理',
      IN_PAY: '支付中',
      PAYING: '支付中',
      PAID: '已支付',
      DELIVERING: '出货中',
      COMPLETED: '已完成',
      FAILED: '失败',
      CANCELLED: '已取消',
      CANCELED: '已取消',
      FULFILLED: '已出货',
      TIMEOUT: '支付超时',
      REFUNDING: '退款中',
      REFUNDED: '已退款',
    },
    statusLoading: '加载中…',
    paidAt: '支付时间',
    createdAt: '创建时间',
    unitPrice: '单价',
    paidAmount: '已支付',
    statusLabel: '状态',
    cardNumber: '卡号',
    cardKey: '卡密',
    invoice: '发票',
    invoiceNo: '发票号',
    invoiceIssued: '已开票',
    invoiceApply: '申请发票',
    invoiceApplyTitle: '申请电子发票',
    invoiceCarrierType: '载具类型',
    invoiceCarrierNone: '无载具（云端存储）',
    invoiceCarrierMobile: '手机条码',
    invoiceCarrierCDC: '载具号码',
    invoiceCarrierEZ: '悠游卡/icash',
    invoiceCarrierEmail: '电子邮件',
    invoiceCarrierDonation: '捐赠发票',
    invoiceCarrierId: '载具号码',
    invoiceCarrierIdPlaceholder: '请输入载具号码',
    invoiceEmail: '电子邮件',
    invoiceEmailPlaceholder: '请输入电子邮件',
    invoiceDonationHint: '发票将捐赠给伊甸社会福利基金会（爱心码 25885）',
    invoiceSubmit: '确认申请',
    invoiceSubmitting: '申请中...',
    invoiceSuccess: '发票申请成功！发票号：{no}',
    invoiceSuccessDonation: '感谢您的爱心捐赠！发票已捐赠给伊甸社会福利基金会',
    invoiceFailed: '发票申请失败，请重试',
    invoiceDuplicate: '该订单已申请过发票',
    invoiceAutoSubmit: '以捐赠提交 ({seconds}s)',
    invoiceAutoSubmitDone: '已自动捐赠发票',
    processSteps: '后续流程步骤',
    redeemInfo: '兑换信息',
    processing: '处理中...',
    loadingPayload: '正在获取卡号/卡密，请稍候…',
    retryPayload: '重新获取卡号/卡密',
    payloadLoaded: '卡号/卡密已获取',
    payloadFailed: '获取卡号/卡密失败，请重试',
    copySuccess: '已复制到剪贴板',
    copyFailed: '复制失败，请手动复制',
    sendCardEmail: '发送卡密到邮箱',
    sendCardEmailTitle: '发送卡密到邮箱',
    sendCardEmailHint: '卡号和卡密将发送到您填写的邮箱，请确保邮箱地址正确',
    sendCardEmailInput: '请输入邮箱地址',
    sendCardEmailSubmit: '发送',
    sendCardEmailSending: '发送中...',
    sendCardEmailSuccess: '卡密已发送，请查收邮件',
    sendCardEmailFailed: '发送失败，请重试',
    qrVerifyTitle: '核销二维码',
    qrVerifyHint: '商家扫描可验证此卡密是否已从机器发放',
    qrVerifyLoading: '二维码生成中…',
    qrVerifyRetry: '重新获取二维码',
    customerContact: '客服联系',
    customerContactNone: '如需帮助请联系工作人员',
    customerContactTitle: '联系客服',
    customerContactClose: '关闭',
  },
  ad: {
    exitTip: '触摸屏幕退出广告',
  },
  // ── E.3-2 maintenance ─────────────────────────────────────────────────────
  maintenance: {
    title: '设备维护中 / Under Maintenance',
    retry: '重试连接',
    network_offline: '网络连接已断开，请检查网络',
    auth_failed: '设备认证失败，请联系运维',
    machine_locked: '设备已被远程锁定',
    dtu_offline: '售卡设备离线，正在等待恢复',
    unknown: '系统发生未知故障',
    reconnecting: '正在尝试重新连接…',
    wsStatus: 'WS 连接状态',
    networkOnline: '网络在线',
    networkOffline: '网络离线',
    contactTitle: '联系运维支持',
    contactPhoneLabel: '热线电话',
    contactPhone: '400-888-0000',
    contactWechat: '@cardshop_support',
    workOrder: '提交工单：support.cardshop.com',
  },
  // ── E.3-2 pay ─────────────────────────────────────────────────────────────
  pay: {
    title: '支付 / Payment',
    summary: '订单摘要',
    orderPayment: '订单支付',
    method: '支付方式',
    cash: '纸钞',
    linepay: 'LinePay',
    card: '信用卡',
    applepay: 'Apple Pay',
    comingSoon: '此支付方式即将开放',
    insertBill: '请投入纸钞',
    remaining: '还需支付',
    completed: '支付完成！',
    cancelled: '支付已取消',
    billReceived: '已投入 {amount}',
    billInsertedFull: '已投入 {inserted}',
    billInsertedStatus: '已投入 {inserted}，还需支付 {remaining}',
    contactSupport: '联系客服',
    cancelOrder: '取消订单',
    timeout: '长时间未操作，请尽快完成支付',
    orderNotFound: '订单不存在，请重新下单',
    fullyPaidRedirect: '支付完成，正在跳转…',
    // ── F.12 新增：找零 / 拒钞 / 超时 ──────────────────────────────────────
    change: {
      label: '请取走找零 {amount}',
    },
    billRejected: '机器暂时未能读取纸钞，请稍候再试。如多次失败请通知工作人员',
    billTimeout: '投钞超时，订单已自动取消，请重新选购',
    countdown: '请在 {time} 内完成投钞，超时订单将自动取消',
    countdownExpired: '订单已超时，请重新选购',
  },
  // ── E.3-2 toast ───────────────────────────────────────────────────────────
  toast: {
    dismiss: '关闭',
  },
  header: {
    online: '在线',
    offline: '离线',
    reconnecting: '重连中',
  },
  footer: {
    online: '网络正常',
    offline: '网络断开',
    reconnecting: '网络重连',
  },
}
